import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { SecurityStepperComponent } from '../../../securitykey/components/security-stepper/security-stepper.component';
import { DocumentService } from '@app/shared/services';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'manage-security-key',
  templateUrl: './manage-security-key.component.html',
  styleUrl: './manage-security-key.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageSecurityKeyComponent implements OnInit, OnDestroy {
  allowedOne = false;
  placeHolder = 'Search Premium Encryption Keys';
  textBoxPlaceHolder = 'Search Premium Encryption Keys';
  unlinkedTemplate = [];
  currentuserId;
  title_type = 'Encryption';
  linkedTemplate = [];
  subscription = new Subscription();
  is_loading = false;
  formName = '';
  selectedTemplate = [];
  disableSearch = false;
  templateConfigurationList = [
    {
      label: `Create new Premium Encryption Key`,
      isGroup: false,
      img: 'assets/images/key-blue.svg',
      isCustomImg: true,
      is_security_key_added: true,
    },
  ];
  object_data = {
    icon_path: 'assets/images/no-encryption-key.svg',
  };

  deleteTemplate(event) {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '500px',
      data: {
        title: 'Remove Premium Encryption',
        materialIcon: 'delete',
        text: `This template will no longer be protected by ${this.linkedTemplate[0].keyName}. You can add an encryption key back to this template at any point in the future.`,
        proceedTitle: 'Delete',
      },
    });

    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((res) => {
        if (res.confirmation) {
          this.is_loading = true;
          this.linkedTemplate = [];
          setTimeout(() => {
            this.is_loading = false;
            this.cd.detectChanges();
          }, 0);
        }
      })
    );
  }

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ManageSecurityKeyComponent>,
    private cd: ChangeDetectorRef,
    private documentService: DocumentService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}
  ngOnInit(): void {
    this.currentuserId = this.data.currentuserId;
    this.formName = this.data.formName;
    this.data.securityKeyData.forEach((element) => {
      this.unlinkedTemplate.push({
        ...element,
        form_name: element.keyName,
        key_path: 'assets/images/key-blue.svg',
        add_new: false,
      });
    });
    if (this.data.addedSecurityKey?.length > 0) {
      this.linkedTemplate.push(this.data.addedSecurityKey[0]);
    }
  }

  selectConnectedUser(item) {
    if (item.add_new) {
      this.openSecurityKeyDialog();
    } else {
      if (this.linkedTemplate.length == 0) {
        this.is_loading = true;
        this.linkedTemplate.push(item);
        this.cd.detectChanges();
      } else {
        this.AskConfirmation(item);
      }
      setTimeout(() => {
        this.is_loading = false;
        this.cd.detectChanges();
      }, 0);
    }
  }
  AskConfirmation(data) {
    const dialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Change Encryption Key ',
        materialIcon: 'info_outline',
        text: `Are you sure you want to change the Encryption key for the ${this.formName} to ${data.keyName}?`,
        proceedTitle: 'Yes, Link it',
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation?.confirmation) {
          setTimeout(() => {
            this.linkedTemplate = [];
            this.linkedTemplate.push(data);
            this.is_loading = false;
            this.cd.detectChanges();
          }, 0);
          // this.is_loading = true;
          this.cd.detectChanges();
        }
      })
    );
  }
  getSecurityKey(linked_data = null) {
    this.subscription.add(
      this.documentService.getSecurityKeyWidhId(this.currentuserId).subscribe((res) => {
        if (res[0].keys.Items != undefined && res[0].keys.Items.length) {
          this.unlinkedTemplate = [];
          res[0].keys.Items.forEach((element) => {
            this.unlinkedTemplate.push({
              ...element,
              form_name: element.keyName,
              key_path: 'assets/images/key-blue.svg',
              add_new: false,
            });
          });
          let findKeyElement = this.unlinkedTemplate.find((x) => x.keyName == linked_data.keyName);

          if (findKeyElement) {
            if (this.linkedTemplate.length) {
              this.AskConfirmation({
                ...findKeyElement,
                form_name: findKeyElement.keyName,
                key_path: 'assets/images/key-blue.svg',
                add_new: false,
              });
            } else {
              this.linkedTemplate = [];
              this.linkedTemplate.push({
                ...findKeyElement,
                form_name: findKeyElement.keyName,
                key_path: 'assets/images/key-blue.svg',
                add_new: false,
              });
            }
          }
          this.cd.detectChanges();
        }
      })
    );
  }

  openSecurityKeyDialog() {
    const dialogRef2 = this.dialog.open(SecurityStepperComponent, {
      panelClass: 'full-window-dialog',
      disableClose: true,
      data: { showkeyName: true, showSecurityKey: true, showHint: true, showSafeguardKey: true },
    });
    this.subscription.add(
      dialogRef2.afterClosed().subscribe((res) => {
        if (res != undefined) {
          if (res?.confirmation) {
            this.getSecurityKey(res.payload);
            // this.linkedTemplate.push({
            //   ...res.payload,
            //   form_name: res.payload.keyName,
            //   key_path: 'assets/images/key-blue.svg',
            //   add_new: false,
            // });
            // this.unlinkedTemplate.push({
            //   ...res.payload,
            //   form_name: res.payload.keyName,
            //   key_path: 'assets/images/key-blue.svg',
            //   add_new: false,
            // });
            // this.isSecurityKeyAdded = true;
            // this.getFormSecurityKey(true);
          } else if (res?.isSkip) {
            // this.isSecurityKeyAdded = false;
          }
        }
      })
    );
    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  closeDialog() {
    this.dialogRef.close({
      linkedTemplate: this.linkedTemplate,
    });
  }
}
